import React, { useEffect } from "react";

interface MicPermissionModalProps {
  isOpen: boolean;
  onRetry?: () => void;
}

const MicPermissionModal: React.FC<MicPermissionModalProps> = ({
  isOpen,
  onRetry,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.body.setAttribute("data-modal-open", "true");
    return () => {
      document.body.style.overflow = original;
      document.body.removeAttribute("data-modal-open");
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      data-modal-overlay
      className="fixed inset-0 z-[9999] flex items-center justify-center cursor-pointer"
      onClick={onRetry}
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-md"
        aria-hidden="true"
      />

      {/* Modal */}
      <div
        data-modal-overlay
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="mic-modal-title"
        aria-describedby="mic-modal-desc"
        className="relative bg-white rounded-[30px] shadow-xl w-[90%] max-w-[600px] mx-4 z-10 flex flex-col items-center px-10 py-10 gap-[30px]"
      >
        {/* Icon */}
        <img
          src="/assets/mic_warning.svg"
          alt="Microphone warning"
          className="w-[132px] h-[130px] flex-shrink-0"
        />

        {/* Text */}
        <div className="flex flex-col items-center gap-[15px]">
          <h2
            id="mic-modal-title"
            className="text-center text-[#252525] font-nunito font-[600] text-[30px] leading-[41px] tracking-[0.2px]"
          >
            EverTutor can't hear you
          </h2>
          <p
            id="mic-modal-desc"
            className="text-center text-[#252525] font-mulish font-[300] text-[18px] leading-[23px] tracking-[0.2px] max-w-[451px]"
          >
            Turn on your browser's microphone and try again.
            <br />
            If it's still not working, ask your teacher for help.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MicPermissionModal;
